/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_officialAnnouncement_requestGetOfficialAnnouncementForNonMember } from '../models/api_officialAnnouncement_requestGetOfficialAnnouncementForNonMember';
import type { api_officialAnnouncement_requestGetOfficialAnnouncementForPortalStaff } from '../models/api_officialAnnouncement_requestGetOfficialAnnouncementForPortalStaff';
import type { api_officialAnnouncement_requestGetOfficialAnnouncementForRequestUser } from '../models/api_officialAnnouncement_requestGetOfficialAnnouncementForRequestUser';
import type { api_officialAnnouncement_requestListOfficialAnnouncementForNonMember } from '../models/api_officialAnnouncement_requestListOfficialAnnouncementForNonMember';
import type { api_officialAnnouncement_responseGetOfficialAnnouncementForNonMember } from '../models/api_officialAnnouncement_responseGetOfficialAnnouncementForNonMember';
import type { api_officialAnnouncement_responseGetOfficialAnnouncementForPortalStaff } from '../models/api_officialAnnouncement_responseGetOfficialAnnouncementForPortalStaff';
import type { api_officialAnnouncement_responseGetOfficialAnnouncementForRequestUser } from '../models/api_officialAnnouncement_responseGetOfficialAnnouncementForRequestUser';
import type { api_officialAnnouncement_responseListOfficialAnnouncementForNonMember } from '../models/api_officialAnnouncement_responseListOfficialAnnouncementForNonMember';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class OfficialAnnouncementService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get OfficialAnnouncement For Non Member
     * 非会員向けに運営からのお知らせを1件取得する
     * @returns api_officialAnnouncement_responseGetOfficialAnnouncementForNonMember responseGetOfficialAnnouncementForNonMember
     * @throws ApiError
     */
    public postOfficialAnnouncementGetForNonMember({
        body,
    }: {
        /**
         * requestGetOfficialAnnouncementForNonMember
         */
        body: api_officialAnnouncement_requestGetOfficialAnnouncementForNonMember,
    }): CancelablePromise<api_officialAnnouncement_responseGetOfficialAnnouncementForNonMember> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/official_announcement/get_for_non_member',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get OfficialAnnouncement For Portal Staff
     * 掲載スタッフ宛に配信された、運営からのお知らせを1件取得する。未配信のお知らせは取得不可。
     * @returns api_officialAnnouncement_responseGetOfficialAnnouncementForPortalStaff responseGetOfficialAnnouncementForPortalStaff
     * @throws ApiError
     */
    public postOfficialAnnouncementGetForPortalStaff({
        body,
    }: {
        /**
         * requestGetOfficialAnnouncementForPortalStaff
         */
        body: api_officialAnnouncement_requestGetOfficialAnnouncementForPortalStaff,
    }): CancelablePromise<api_officialAnnouncement_responseGetOfficialAnnouncementForPortalStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/official_announcement/get_for_portal_staff',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get OfficialAnnouncement For Request User
     * 依頼ユーザー宛に配信された、運営からのお知らせを1件取得する。未配信のお知らせは取得不可。
     * @returns api_officialAnnouncement_responseGetOfficialAnnouncementForRequestUser responseGetOfficialAnnouncementForRequestUser
     * @throws ApiError
     */
    public postOfficialAnnouncementGetForRequestUser({
        body,
    }: {
        /**
         * requestGetOfficialAnnouncementForRequestUser
         */
        body: api_officialAnnouncement_requestGetOfficialAnnouncementForRequestUser,
    }): CancelablePromise<api_officialAnnouncement_responseGetOfficialAnnouncementForRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/official_announcement/get_for_request_user',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List OfficialAnnouncement For Non Member
     * 非会員向けに運営からのお知らせの一覧を取得する
     * @returns api_officialAnnouncement_responseListOfficialAnnouncementForNonMember responseListOfficialAnnouncementForNonMember
     * @throws ApiError
     */
    public postOfficialAnnouncementListForNonMember({
        body,
    }: {
        /**
         * requestListOfficialAnnouncementForNonMember
         */
        body: api_officialAnnouncement_requestListOfficialAnnouncementForNonMember,
    }): CancelablePromise<api_officialAnnouncement_responseListOfficialAnnouncementForNonMember> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/official_announcement/list_for_non_member',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
